import React, { useContext, useEffect, useRef } from "react";
import YouTube from "react-youtube";
import { MediaContext } from "../../context/MediaContext";
import classNames from "classnames";
import { toastError, toastQuestion } from "../../utils/Toast";
import { useTranslation } from "react-i18next";
import { SocketContext } from "../../context/SocketContext";

const LectureVideoPlayer = ({ videoId, mainContent, setStopped, setDuration }) => {
  const { t } = useTranslation("", { keyPrefix: "lecture.video_page" });
  const { setPlayer, getVideoTs } = useContext(MediaContext);
  const { chatMessages } = useContext(SocketContext);

  const interval = useRef(null);

  const opts = {
    playerVars: {
      playsinline: 0,
      modestbranding: 1,
      showinfo: 0,
      controls: 1,
      rel: 0,
    },
  };

  const checkSecond = () => {
    const second = getVideoTs();
    Object.values(chatMessages)
      .filter((m) => m.videoTs === second && m.isQuestion)
      .forEach((m) => toastQuestion(m));
  };

  const onReady = (e) => {
    setPlayer(e.target);
    setDuration(e.target.getDuration());
  };

  const onPause = () => {
    setStopped(true);
    if (interval.current) clearInterval(interval.current);
    interval.current = null;
  };

  const onError = () => {
    toastError(t("toast.video_error"));
  };

  const onPlay = () => {
    setStopped(false);
    if (interval.current) clearInterval(interval.current);
    interval.current = setInterval(checkSecond, 1000);
  };

  useEffect(() => {
    return () => {
      if (interval.current) clearInterval(interval.current);
    };
  }, []);

  return (
    <YouTube
      className={classNames("youtube-video", {
        "main-content": mainContent,
        "secondary-content": !mainContent,
      })}
      videoId={videoId}
      opts={opts}
      onReady={onReady}
      onPause={onPause}
      onError={onError}
      onPlay={onPlay}
    />
  );
};

export default LectureVideoPlayer;
